import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, CircularProgress, MenuItem, Paper, TextField, Typography } from '@mui/material'
import { groupCreationService } from '../../services/groupCreationService'

// Search users by email and select one as the admin. `groupId` is the "all
// users" group whose admin permissions gate the search endpoint.
const AdminSearch = ({ groupId, selected, onSelect, onClear }) => {
  const [email, setEmail] = useState('')
  const [results, setResults] = useState([])
  const [searching, setSearching] = useState(false)

  useEffect(() => {
    if (selected || email.length < 3) {
      setResults([])
      return
    }
    const controller = new AbortController()
    setSearching(true)
    const timeout = setTimeout(() => {
      groupCreationService.searchUsers(groupId, email, controller.signal)
        .then(users => setResults(users || []))
        .catch(() => {})
        .finally(() => setSearching(false))
    }, 350)

    return () => {
      controller.abort()
      clearTimeout(timeout)
    }
  }, [groupId, email, selected])

  const clear = () => {
    setEmail('')
    setResults([])
    onClear()
  }

  if (selected) {
    return (
      <div className='flex items-center justify-between mb-5 p-3 border rounded'>
        <span>
          <strong>{selected.name || 'Unnamed user'}</strong>
          <span className='text-gray-500 ml-2'>{selected.email}</span>
        </span>
        <Button size='small' onClick={clear}>Change</Button>
      </div>
    )
  }

  return (
    <div className='mb-5'>
      <TextField
        variant='outlined'
        fullWidth
        label='Search admin by email'
        value={email}
        onChange={e => setEmail(e.target.value)}
        InputProps={{ endAdornment: searching ? <CircularProgress size={18} /> : null }}
      />
      {results.length > 0 &&
        <Paper variant='outlined' className='mt-1 max-h-60 overflow-auto'>
          {results.map(user => (
            <MenuItem key={user.id} onClick={() => { onSelect(user); setResults([]) }}>
              <span>
                <strong>{user.name || 'Unnamed user'}</strong>
                <span className='text-gray-500 ml-2'>{user.email}</span>
              </span>
            </MenuItem>
          ))}
        </Paper>}
      {!searching && email.length >= 3 && results.length === 0 &&
        <Typography variant='body2' className='text-gray-500 mt-1'>No users found.</Typography>}
    </div>
  )
}

AdminSearch.propTypes = {
  groupId: PropTypes.string.isRequired,
  selected: PropTypes.object,
  onSelect: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
}

export default AdminSearch
